<template>
  <li role="presentation">
    <button
      v-if="type === 'button'"
      role="menuitem"
      type="button"
      class="dropdown-item"
      :class="elementClasses"
      @mousedown="handleClick"
    >
      <slot />
    </button>
    <a
      v-else-if="type === 'link' && !to"
      role="menuitem"
      :href="href"
      target="_self"
      class="dropdown-item"
      :class="elementClasses"
      @mousedown="handleClick"
    >
      <slot />
    </a>
    <button
      v-else
      role="menuitem"
      target="_self"
      class="dropdown-item"
      :class="elementClasses"
      @mousedown="handleRouteClick"
    >
      <slot />
    </button>
  </li>
</template>

<script>

  export default {
    name: 'FabricDropdownElement',
    props: {
      type: {
        type: String,
        default: 'button',
      },
      elementClasses: {
        type: String,
        default: '',
      },
      href: {
        type: String,
        default: '#',
      },
      to: {
        type: [String, Object],
        default: () => null,
      },
    },
    methods: {
      handleRouteClick(){
        this.$router.push(this.to)
        this.handleClick()
      },
      handleClick() {
        this.$emit('click')
      }
    },
  }
</script>
